import React from 'react';
import { LockIcon, ZapIcon, ShieldCheckIcon, MonitorSmartphoneIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
const miniBadges = [{
  emoji: '📚',
  label: '6 Tomos'
}, {
  emoji: '🎁',
  label: '5 Bonos Pro'
}, {
  emoji: '📄',
  label: '300+ Páginas'
}, {
  emoji: '💬',
  label: 'Guiones de WhatsApp listos para copiar'
}, {
  emoji: '🌍',
  label: 'Funciona en cualquier país hispanohablante'
}];
const trustItems = [{
  Icon: LockIcon,
  label: 'Pago seguro'
}, {
  Icon: ZapIcon,
  label: 'Descarga inmediata'
}, {
  Icon: ShieldCheckIcon,
  label: 'Garantía de 7 días'
}, {
  Icon: MonitorSmartphoneIcon,
  label: '100% digital (PDF)'
}];
export function Hero() {
  return <section className="relative w-full bg-ivory overflow-hidden" data-id="element-136" data-mp="ncq13df73mna">
      <div className="mx-auto max-w-6xl px-5 pt-10 pb-16 sm:pt-16 sm:pb-24" data-id="element-137" data-mp="neazje4mrpqf">
        <div className="flex justify-center" data-id="element-138" data-mp="3d33d6tuq0lin">
          <span className="inline-flex max-w-2xl items-center gap-2 border border-gold-soft bg-gold-tint px-4 py-2 text-center text-[10px] sm:text-[11px] uppercase tracking-[0.24em] text-ink-soft" data-id="element-139" data-mp="382p5jcx17dl5">
            <span aria-hidden="true" className="text-gold-dark" data-id="element-140" data-mp="3o7c05xxxspgm">
              ◆
            </span>
            Wedding Pro OS™ — El manual de operaciones que las agencias de bodas no te
            muestran
          </span>
        </div>

        <h1 className="mt-8 text-center font-serif text-[2rem] leading-[1.14] sm:text-[3.4rem] sm:leading-[1.1] text-ink" data-id="element-141" data-mp="3e84n7bv46wu1">
          Deja de dar <span className="italic text-gold-dark" data-id="element-142" data-mp="30g6mnpfgy99h">&ldquo;precio de amiga&rdquo;</span>.
          Empieza a cobrar como la wedding planner que ya eres
          <span className="text-ink-soft" data-id="element-143" data-mp="2qkwkn1p2m1vp">
             — aunque tu único cliente hoy sea la boda de tu prima.
          </span>
        </h1>

        <div className="rule-gold mx-auto mt-8 w-40" aria-hidden="true" data-id="element-144" data-mp="2vgu1d948xa90" />

        <p className="mx-auto mt-8 max-w-3xl text-center text-base sm:text-lg leading-relaxed text-ink-soft" data-id="element-145" data-mp="2hjoyfhztwrhz">
          No es un curso. Es el sistema operativo completo de una agencia de bodas, en 6
          tomos y 300+ páginas: los guiones exactos de WhatsApp, el protocolo para cuando te
          dejan en visto, los números reales de tu negocio y cómo captar tus propias novias
          sin pagarle cuota a un portal.{' '}
          <span className="font-medium text-ink" data-id="element-146" data-mp="i9vqp37erylb">Todo listo, lo usas esta noche.</span>
        </p>

        <ul className="mx-auto mt-8 flex max-w-3xl flex-wrap items-center justify-center gap-x-3 gap-y-2" data-id="element-147" data-mp="dbaoiy8lj4u8">
          {miniBadges.map(badge => <li key={badge.label} className="inline-flex items-center gap-2 rounded-full border border-ink/10 bg-white px-3.5 py-1.5 text-xs text-ink-soft" data-id="element-148" data-mp="162ued0zp7h57">
              <span aria-hidden="true" data-id="element-149" data-mp="x030yvn9ibax">{badge.emoji}</span>
              {badge.label}
            </li>)}
        </ul>

        <div className="mt-10 flex justify-center" data-id="element-150" data-mp="3lu9vowr7fq94">
          <CtaButton data-id="element-151" data-mp="3hqu105yp3zz2">Quiero instalar el sistema — Acceso inmediato</CtaButton>
        </div>

        <ul className="mt-6 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-[11px] uppercase tracking-[0.16em] text-ink-muted" data-id="element-152" data-mp="1x9krqeihcqdi">
          {trustItems.map(({
          Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-2" data-id="element-153" data-mp="26a999j7318v5">
              <Icon className="h-3.5 w-3.5 text-gold-dark" aria-hidden="true" data-id="element-154" data-mp="26869w8k1i3dr" />
              {label}
            </li>)}
        </ul>

        <figure className="mt-14 sm:mt-16" data-id="element-155" data-mp="2g0lqb1foujwj">
          <div className="mx-auto max-w-4xl border border-gold-soft bg-white p-3 shadow-card" data-id="element-156" data-mp="2g1wv94kvdxp8">
            <img src="https://cdn.magicpatterns.com/patterns/generated-images/5662ec8c-4fab-4fcf-9979-15cb62392974.jpg" alt="Los seis tomos del Wedding Pro OS sobre un escritorio marfil, con agenda, teléfono mostrando una conversación de WhatsApp y lapicera dorada" className="w-full object-cover" loading="eager" data-id="element-157" data-mp="2kx2hy5m3jged" />
          </div>
        </figure>
      </div>
    </section>;
}